import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './language/i18n'

//网页链接合成
let address = ''
let arr = window.location.host.split('.')
if(arr.length == 3 && arr[0] == 'pc'){
  address = arr[1] + '.' + arr[2]
}else if(arr.length == 3 && arr[0] == 'www'){
  address = 'pc.' + arr[1] + '.' + arr[2]
}else{
  address = 'pc.' + arr[0] + '.' + arr[1]
}

if (window.innerWidth > 800) {
  if (window.location.pathname === '/register') {
    const strArr = window.location.href.split('?')
    let url = 'https://' + address + '/register'
    if (strArr[1]) {
      url = `${url}?${strArr[1]}`
    }
    window.open(url, '_self')
  } else if (window.location.pathname === '/') {
    const strArr = window.location.href.split('?')
    let url = 'https://' + address + '/home'
    if (strArr[1]) {
      url = `${url}?${strArr[1]}`
    }
    window.open(url, '_self')
  } else {
    window.open('https://' + address + '/home', '_self')
  }
} else {
    createApp(App).use(store).use(router).use(i18n).mount('#app')
}

